// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"8":"61f7a03f","248":"ffb5cb8e","367":"15039dbe","992":"71eda807"}[chunkId] + ".css";
};